import * as yup from 'yup';

export interface IStepNotifications {
    terms: boolean;
}
export const stepNotificationsInitialValues: IStepNotifications = {
    terms: false
}

export const stepNotificationsSchema = yup.object().shape({
    terms: yup.boolean().oneOf([true], 'required'),
})
